import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Helmet } from 'react-helmet-async';

const API_URL = process.env.NODE_ENV === 'production' 
  ? '' // Bruker en relativ sti i produksjon
  : 'http://localhost:5000'; // Beholder den gamle for lokal utvikling

function NewsListPage() {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    axios.get(`${API_URL}/api/articles`)
      .then(res => setArticles(res.data))
      .catch(err => console.error("Error fetching articles:", err));
  }, []);

  if (articles.length === 0) {
    return <div className="container">Laster inn nyheter...</div>;
  }

  return (
    <div>
      <Helmet>
      <title>Nyhetsarkiv – Sunnfjord Naprapatsenter</title>
      <meta name="description" content="Les nyheter, artikler og helsetips fra naprapat Alexander Øen Ask. Hold deg oppdatert på behandling og forebygging av plager." />
    </Helmet>
      <h1>Nyhetsarkiv</h1>
      <div className="news-list">
        {articles.map(article => (
          <div key={article.slug} className="card news-list-item">
            <h2>{article.title}</h2>
            <p className="article-date">Publisert: {new Date(article.created_at).toLocaleDateString('nb-NO')}</p>
            <p>{article.intro_text}</p>
            <Link to={`/nyheter/${article.slug}`} className="button">
              Les mer
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default NewsListPage;